import React, { useState } from 'react';
import './ChatWithRooty.css';
import { Link } from 'react-router-dom';

function ChatWithRooty() {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([
    { sender: 'bot', text: "Hi! I'm Rooty 🌿. How can I help with your lawn today?" }
  ]);
  const [loading, setLoading] = useState(false);

  // ---- Speech Recognition ----
  const handleSpeechInput = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Speech recognition is not supported in this browser.");
      return;
    }
    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.onresult = (event) => {
      setInput(event.results[0][0].transcript);
    };
    recognition.start();
  };

  // ---- Text-to-Speech ----
  const speak = (text) => {
    if ("speechSynthesis" in window) {
      const utter = new window.SpeechSynthesisUtterance(text);
      utter.lang = "en-US";
      window.speechSynthesis.speak(utter);
    }
  };

  const handleSend = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: 'user', text: input };
    setMessages(prev => [...prev, userMessage]);
    setLoading(true);

    try {
      const body = {
        messages: [
          { role: 'system', content: "You're Rooty, a funny but practical lawn care expert. Always promote Brandon's services if appropriate." },
          ...messages
            .filter(m => m.sender !== 'bot' || m.text !== "Hi! I'm Rooty 🌿. How can I help with your lawn today?")
            .map(m => ({
              role: m.sender === 'user' ? 'user' : 'assistant',
              content: m.text
            })),
          { role: 'user', content: input }
        ],
        max_tokens: 512
      };

      const res = await fetch(
        'https://zones-demo-openai.openai.azure.com/openai/deployments/Rooty/chat/completions?api-version=2025-01-01-preview',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'api-key': 'AbsAo9SeD8UrxnLSNDlsM5M9y518KyVpU2fSyZYCL26KHui1GzkaJQQJ99BCACYeBjFXJ3w3AAABACOGySOO'
          },
          body: JSON.stringify(body)
        }
      );
      const data = await res.json();
      const reply = data.choices?.[0]?.message?.content || 'No answer!';
      setMessages(prev => [
        ...prev,
        { sender: 'bot', text: reply }
      ]);
      speak(reply);
    } catch (err) {
      setMessages(prev => [...prev, { sender: 'bot', text: 'Oops! Something went wrong.' }]);
    }

    setInput('');
    setLoading(false);
  };

  return (
    <div className="chat-page">
      <header className="chat-header">
        <img src="/assets/icons/AI/rooty.png" alt="Rooty the AI Assistant" className="chat-avatar" />
        <h1>Chat with Rooty</h1>
        <p>Your friendly (and slightly sassy) lawn care guru for West Central Florida! 🌱🐝</p>
      </header>

      <div className="chat-instructions">
        <h2>How to Use Rooty</h2>
        <ul>
          <li>Type your lawn care question in the box below and hit <strong>Send</strong></li>
          <li>Or click the <strong>🎤 mic</strong> to ask by voice</li>
          <li>Rooty will reply with helpful tips and sometimes a buzz of humor 🐝</li>
          <li>Ask about watering schedules, fertilizer, pest control, lawn types, or landscaping ideas</li>
        </ul>

        <h3>Try questions like:</h3>
        <ul>
          <li>"How often should I water my St. Augustine grass in Bradenton?"</li>
          <li>"What’s the best time to fertilize in the summer?"</li>
          <li>"Help! My lawn has chinch bugs!"</li>
          <li>"Is it worth hiring a pro like Brandon or should I keep struggling?"</li>
        </ul>
      </div>

      <div className="chatbot-container">
        <div className="chat-messages">
          {messages.map((msg, idx) => (
            <div key={idx} className={`chat-message ${msg.sender}`}>{msg.text}</div>
          ))}
          {loading && (
            <div className="chat-message bot thinking">
              <span>Rooty is thinking...</span>
              <span className="thinking-dots">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
            </div>
          )}
        </div>
        <div className="chat-input">
          <button onClick={handleSpeechInput} title="Speak to Rooty" disabled={loading}>🎤</button>
          <input
            type="text"
            placeholder="Type your lawn care question..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            disabled={loading}
          />
          <button onClick={handleSend} disabled={loading || !input.trim()}>Send</button>
        </div>
      </div>

      <div className="chat-nav-buttons">
        <Link to="/" className="chat-nav-button">← Back to Main Page</Link>
        <a href="#contact" className="chat-nav-button">Request a Quote</a>
      </div>

      <footer className="chat-footer">
        <p>
          Rooty is powered by Azure AI and a ton of lawn care wisdom courtesy of The Neighborhood Buzz.
          When in doubt, hire Brandon — he's insured, experienced, and his work speaks for itself. 😉
        </p>
      </footer>
    </div>
  );
}

export default ChatWithRooty;



